class ContactDataModel {
  address?: Nullable<string>;
  company?: Nullable<string>;
  email?: Nullable<string>;
  logo?: Nullable<string>;
  person?: Nullable<string>;
  phone?: Nullable<string>;
  title?: Nullable<string>;
  website?: Nullable<string>;
  whatsapp?: Nullable<string>;
}

export class ContactData extends ContactDataModel {
  constructor(modelData: ContactDataModel) {
    super();

    Object.keys(modelData).forEach((key) => {
      this[key] = modelData[key];
    });
  }
}
